export default __webpack_public_path__ + "static/media/adelidusiam.e8c597ce.jpg";